export default __webpack_public_path__ + "static/industryAdaptBg-c99ab29427b7179b24b2ce43f4aa4943.png";